import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/responses']['DELETE'];
type Input = ThisApi['params'] & ThisApi['query'];

const deleteQuestionnaireResponse = async ({
  fieldTemplateKey,
  questionnaireId,
  rowResponseId,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/responses', { questionnaireId });
  const data = await formsBackendClient.delete(path, {
    params: { fieldTemplateKey, rowResponseId },
  });
  return data.data;
};

export default deleteQuestionnaireResponse;
